var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.currentComponent,_vm._g({tag:"component",attrs:{"value":_vm.isModalOpen,"carEntity":_vm.carEntity,"strategy":_vm.strategy}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }